import React from 'react'
import {
  ActionWrapper,
  DimmingProfileEditorActions,
  DimmingProfileEditorState,
  PassThroughAction,
} from './types/presenter.types'
import { DimmingProfileUiStrings } from './i18n/dimmingProfileI18n'
import ProfileCurve from './components/ProfileCurve'
import ActiveDaysSelector from './components/ActiveDaysSelector'
import DaliAddressSelector from './components/DaliAddressSelector'
import StepList from './components/StepList'

interface DimmingProfileEditorViewProps {
  state: DimmingProfileEditorState
  actions: DimmingProfileEditorActions
  svgRef: React.RefObject<SVGSVGElement>
  strings: DimmingProfileUiStrings
  readOnly?: boolean
  actionWrapper?: ActionWrapper
}

export const DimmingProfileEditorView: React.FC<DimmingProfileEditorViewProps> = ({
  state,
  actions,
  svgRef,
  strings,
  readOnly = false,
  actionWrapper = PassThroughAction,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
      <ProfileCurve
        state={state}
        actions={actions}
        svgRef={svgRef}
        strings={strings}
        readOnly={readOnly}
      />

      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 16,
          alignItems: 'flex-start',
        }}
      >
        <ActiveDaysSelector
          activeDays={state.activeDays}
          onToggle={actions.toggleDay}
          strings={strings}
          disabled={readOnly}
        />
        <DaliAddressSelector
          value={state.daliValue}
          addressByte={state.daliAddress}
          onModeChange={actions.setDaliMode}
          onIdChange={actions.setDaliId}
          strings={strings}
          disabled={readOnly}
        />
      </div>

      <StepList
        state={state}
        actions={actions}
        strings={strings}
        readOnly={readOnly}
        actionWrapper={actionWrapper}
      />
    </div>
  )
}

export default DimmingProfileEditorView
